import FloatingDismissIcon from './ic_dismiss_16x16.svg';
import FloatingGreenIcon from './icon_floating_green.svg';
import FloatingMembershipIcon from './icon_floating_membership.svg';
import FloatingOrangeIcon from './icon_floating_orange.svg';
import FloatingSolidIcon from './icon_floating_solid.svg';
import FloatingStrokeIcon from './icon_floating_stroke.svg';
import FloatingTransparantIcon from './icon_floating_transparant.svg';

export {
  FloatingDismissIcon,
  FloatingGreenIcon,
  FloatingMembershipIcon,
  FloatingOrangeIcon,
  FloatingSolidIcon,
  FloatingStrokeIcon,
  FloatingTransparantIcon,
};
